// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { MediaFieldsets, type SearchFormValue } from './SearchForm';
import { mediaUgcType } from './SearchForm/config/fields.config';

const { name: UGCTYPENAME } = mediaUgcType;

export default class MediaSearch extends React.PureComponent<*> {
  static label = 'Images & Video';

  patchUgcType(val: SearchFormValue) {
    return !val.get(UGCTYPENAME) ? val.set(UGCTYPENAME, 'Image Video') : val;
  }

  render() {
    return (
      <SearchView
        label={MediaSearch.label}
        primaryFieldsets={MediaFieldsets.primaryFieldsets}
        extraFieldsets={MediaFieldsets.extraFieldsets}
        onSubmit={this.patchUgcType}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/Media.js